jQuery(($) => {
    const videoTextModules = $('.video-text.module')

    if (videoTextModules.length === 0) {
        return
    }

    // Ensure the wistia queue exists
    window._wq = window._wq || []

    videoTextModules.each((i, heroModule) => {
        // Setup watch video button click interactions
        $('.cta-button', heroModule).click((e) => {
            if (!$("#video", heroModule).hasClass("video-active")) {
                return
            }

            e.preventDefault()

            // This ensures the button's state resets
            setTimeout(() => e.target.blur(), 10)

            // Ensure the video is loaded
            if (!heroModule.classList.contains('video-loaded')) {
                return loadVideo(heroModule)
            }

            $('img', heroModule).click()
        })
    })

    const loadVideo = (heroModule) => {
        heroModule.classList.add('video-loaded')

        // Load the wistia video
        const videoId = $('.wistia_embed', heroModule).data('video-id')
        loadWistiaMedia(videoId)

        loadWistiaLibrary()

        // Start the video once it's loaded
        _wq.push({
            id: videoId,
            onReady: (video) => $(`.wistia_async_${videoId} img`, heroModule).click()
        })
    }
})
